import BaseCrudService from './baseCrud.service'

class ChatService extends BaseCrudService {
  constructor () {
    super('chat', {
      id: false
    })
  }

  sendMessage (itemId, messageData, ...callbacks) {
    return this.constructor.put(
      this.endpoints().sendMessage.replace('{:id}', itemId),
      messageData,
      ...callbacks
    )
  }

  createChatIfNotExists (slug, ...callbacks) {
    return this.constructor.post(
      this.endpoints().create,
      {
        slug: slug
      },
      ...callbacks
    )
  }

  getMessages (itemId, params, ...callbacks) {
    params = params || { sort: '-id', page: 1 }
    return this.constructor.get(
      this.endpoints().getMessages.replace('{:id}', itemId),
      {
        params: Object.assign({
          sort: params.sort,
          page: params.page,
          q: params.q
        },
        {
          filters: JSON.stringify(params.filter)
        })
      }, ...callbacks)
  }
}

export default ChatService
